import React, { useCallback, useState } from 'react';

import FormatOptionLabel, {
    type FormatOption,
} from 'js/src/components/common/ui/FormatOptionLabel';
import Select from 'js/src/components/common/ui/Select/Select';
import { AI_VOICE_SPEED_OPTIONS } from 'js/src/data/ai-voices-and-avatars';

const SPEED_OPTIONS: FormatOption<number>[] = AI_VOICE_SPEED_OPTIONS.map((option) => ({
    label: option.label,
    subLabel: option.displayRate,
    value: option.value,
}));
const NORMAL_SPEED = SPEED_OPTIONS.find((option) => option.value === 1)!;

type AIVoiceSpeedProps = {
    className?: string;
    dropUp?: boolean;
    selectedSpeed: number | null;
    onSpeedChange: (speed: number) => void;
};

const AIVoiceSpeed: React.FC<AIVoiceSpeedProps> = ({
    className,
    dropUp = true,
    selectedSpeed,
    onSpeedChange,
}) => {
    const [selectedOption, setSelectedOption] = useState<FormatOption<number>>(() => {
        const option = SPEED_OPTIONS.find((option) => option.value === selectedSpeed);
        return option ?? NORMAL_SPEED;
    });

    const handleSpeedChange = useCallback(
        (speed: number) => {
            const option = SPEED_OPTIONS.find((opt) => opt.value === speed);
            if (option) setSelectedOption(option);
            onSpeedChange(speed);
        },
        [onSpeedChange],
    );

    return (
        <Select
            isMulti={false}
            options={SPEED_OPTIONS}
            value={selectedOption}
            className={className}
            onChange={handleSpeedChange}
            dropUp={dropUp}
            formatOptionLabel={(option, { context }) => (
                <FormatOptionLabel
                    option={option}
                    icon={context === 'value' ? 'speed' : undefined}
                    iconStyleClasses={'me-l5-8'}
                    subLabelStyleClasses={'color-grey-600 ms-l5-4'}
                />
            )}
        />
    );
};

export default AIVoiceSpeed;
